/*
 * @Author: M.D.
 * @Date: 2019-12-09 10:24:26
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'

import getters from './getters'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  // strictMode: false,
  key: 'kt-mall-vuex'
  // storage: window.localStorage,
  // reducer: (state) => ({ user: state.user }) // only save user module
  // filter: (mutation) => mutation.type == 'addNavItem' // 设置触发存储的mutation
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app
  },
  getters,
  plugins: [vuexLocal.plugin]
})
